/**
 * JS oznámení o použití cookies na webu
 */

import './scss/index.scss';
import motive from './img/motive.gif';

// eslint-disable-next-line no-unused-vars
const VERSION = '3.1.3';

const FRAGMENTS = {
  ACCEPT_ALL_BTN:                        '[data-fragment="cp.acceptAllBtn"]',
  ACCEPT_SELECTED_BTN:                   '[data-fragment="cp.acceptSelectedButton"]',
  CLOSE_BTN:                             '[data-fragment="cp.closeButton"]',
  OPEN_SETTINGS_BTN:                     '[data-fragment="cp.openSettingsButton"]',
  OPEN_SETTINGS_LINK:                    '[data-fragment="cp.openSettingsLink"]',
  PANE:                                  '[data-fragment="cp.pane"]',
  SETTINGS:                              '[data-fragment="cp.settings"]',
  SETTINGS_CHECKBOX_ANALYTICS:           '[data-fragment="cp.checkboxAnalytics"]',
  SETTINGS_CHECKBOX_ANALYTICS_MARKETING: '[data-fragment="cp.checkboxAnalyticsMarketing"]',
  SETTINGS_CHECKBOX_MARKETING:           '[data-fragment="cp.checkboxMarketing"]',
  SETTINGS_CLOSE_BTN:                    '[data-fragment="cp.settingsCloseButton"]',
  SETTINGS_STATE_TEXT:                   '[data-fragment="cp.settingsStateText"]',
  TECHNICAL_BTN:                         '[data-fragment="cp.technicalButton"]',
};

const LEVEL = {
  CONFIG:              1, // uzivatel videl panel a chce nastavit uroven
  TECHNICAL:           2, // uz. souhlasi s technickymi cookies (min uroven po ulozeni nastaveni)
  ANALYTICS:           3, // uz. souhlasi s technickymi A analytickymi cookies (nepouzito)
  MARKETING:           4, // uz. souhlasi s technickymi A marketingovymi cookies
  ANALYTICS_MARKETING: 5, // uz. souhlasi s technickymi A analytickymi A marketingovymi cookies
};

/**
 * Deep merge of multiple Objects
 *
 * Examples:
 * obj = merge({x: {a: 2}}, {x: {b: 3}})                => { x: { a: 2, b: 3 } }
 * obj = merge({x: {a: 2}}, {x: {b: 3}}, {x: {a: 1}})   => { x: { a: 1, b: 3 } }

 * @return {{}}
 */
const merge = function () {
  let ret = {},
      i  = 0,
      il = arguments.length,
      p;
  for (; i < il; i++) {
    for (p in arguments[ i ]) {
      try {
        if (arguments[ i ][ p ].constructor == Object) {
          ret[ p ] = merge(ret[ p ], arguments[ i ][ p ]);
        } else {
          ret[ p ] = arguments[ i ][ p ];
        }
      } catch (e) {
        ret[ p ] = arguments[ i ][ p ];
      }
    }
  }
  return ret;
};

window.dataLayer = window.dataLayer || [];
const gtag = function () { window.dataLayer.push(arguments); };

export class CookiePolicy {
  static defaultProps = {
    activeSettingsClassName: 'cookies-settings--active',
    disableRwdImg: true,
    disableRwdImgClassName: 'cookies-policy--disable-rwd-img',
    enableCloseButton: false,
    enableIframe: false,
    enableImg: true,
    enableModal: false,
    enableModalClassName: 'cookies-policy--modal',
    enableOneGTMContainer: false,
    enableSplitGTMContainer: false,
    enableTechnicalButton: false,
    excludedSelectors: [],
    hiddenClassName: 'cookies-policy--hidden',
    imgSrc: motive,
    template: data => `
      <section class="cookies-policy ${ data.disableRwdImg } ${ data.enableModal }" data-fragment="cp.pane">
        <div class="cookies-policy__container">
          ${ data.enableCloseButton ? `<button class="cookies-policy__btn-close" data-fragment="cp.closeButton"><span class="cookies-policy__btn-close-text">${ data.closeBtn }</span></button>` : '' }
          ${ data.enableImg ? `<header class="cookies-policy__header"><img class="cookies-policy__img" src="${ data.imgSrc }" alt="" /></header>` : '' }
          <div class="cookies-policy__main">
            <h2 class="cookies-policy__heading">${ data.heading }</h2>
            <p class="cookies-policy__perex">${ data.perex }</p>
            <div class="cookies-policy__buttons">
              <button class="cookies-policy__btn cookies-policy__btn--secondary" data-fragment="cp.openSettingsButton">${ data.settingsBtn }</button>
              ${ data.enableTechnicalButton ? `<button class="cookies-policy__btn cookies-policy__btn--technical" data-fragment="cp.technicalButton">${ data.technicalBtn }</button>` : '' }
              <button class="cookies-policy__btn cookies-policy__btn--primary" data-fragment="cp.acceptAllBtn">${ data.acceptAllBtn }</button>
            </div>
          </div>
        </div>
      </section>`,
    settingsTemplate: settingsData => `
      <section class="cookies-settings" data-fragment="cp.settings">
        <div class="cookies-settings__container">
          <header class="cookies-settings__header">
            <button class="cookies-settings__btn-close" data-fragment="cp.settingsCloseButton"><span class="cookies-settings__btn-close-text">${ settingsData.closeBtn }</span></button>
            <h2 class="cookies-settings__heading">${ settingsData.heading }</h2>
            <p class="cookies-settings__perex">${ settingsData.perex }</p>
            <div class="cookies-settings__buttons">
              <button class="cookies-settings__btn cookies-settings__btn--primary" data-fragment="cp.acceptAllBtn">${ settingsData.acceptAllBtn }</button>
            </div>
          </header>
          <div class="cookies-settings__main">
            <section class="cookies-settings__section">
              <header class="cookies-settings__section-header">
                <h3 class="cookies-settings__section-title">${ settingsData.technicalTitle }</h3>
                <div class="cookies-settings__section-state-container">
                  <span class="cookies-settings__section-state cookies-settings__section-state--on">${ settingsData.technicalState }</span>
                </div>
              </header>
              <div class="cookies-settings__section-main">
                <p class="cookies-settings__section-perex">${ settingsData.technicalPerex }</p>
              </div>
            </section>
            ${ settingsData.enableSplitGTMContainer ? `
            <section class="cookies-settings__section">
               <header class="cookies-settings__section-header">
                 <h3 class="cookies-settings__section-title">${ settingsData.analyticsTitle }</h3>
                 <div class="cookies-settings__section-state-container">
                   <input id="analytics-cookies" class="cookies-settings__checkbox" type="checkbox" name="analyticsCookies" value="analyticsCookies" data-fragment="cp.checkboxAnalytics">
                   <label class="cookies-settings__label cookies-settings__section-state" for="analytics-cookies"><span class="cookies-settings__switch"></span><span class="cookies-settings__section-state-text" data-fragment="cp.settingsStateText">${ settingsData.checkboxStateOff }</span></label>
                 </div>
               </header>
               <div class="cookies-settings__section-main">
                 <p class="cookies-settings__section-perex">${ settingsData.analyticsPerex }</p>
               </div>
            </section>
            <section class="cookies-settings__section">
              <header class="cookies-settings__section-header">
                <h3 class="cookies-settings__section-title">${ settingsData.marketingTitle }</h3>
                <div class="cookies-settings__section-state-container">
                  <input id="marketing-cookies" class="cookies-settings__checkbox" type="checkbox" name="marketingCookies" value="marketingCookies" data-fragment="cp.checkboxMarketing">
                  <label class="cookies-settings__label cookies-settings__section-state" for="marketing-cookies"><span class="cookies-settings__switch"></span><span class="cookies-settings__section-state-text" data-fragment="cp.settingsStateText">${ settingsData.checkboxStateOff }</span></label>
                </div>
              </header>
              <div class="cookies-settings__section-main">
                <p class="cookies-settings__section-perex">${ settingsData.marketingPerex }</p>
              </div>
            </section>` : `
            <section class="cookies-settings__section cookies-settings__section--analytics-marketing">
              <header class="cookies-settings__section-header">
                <h3 class="cookies-settings__section-title">${ settingsData.analyticsMarketingTitle }</h3>
                <div class="cookies-settings__section-state-container">
                  <input id="analytics-marketing-cookies" class="cookies-settings__checkbox" type="checkbox" name="analyticsMarketingCookies" value="analyticsMarketingCookies" data-fragment="cp.checkboxAnalyticsMarketing">
                  <label class="cookies-settings__label cookies-settings__section-state" for="analytics-marketing-cookies"><span class="cookies-settings__switch"></span><span class="cookies-settings__section-state-text" data-fragment="cp.settingsStateText">${ settingsData.checkboxStateOff }</span></label>
                </div>
              </header>
              <div class="cookies-settings__section-main">
                <h4 class="cookies-settings__section-sub-title">${ settingsData.analyticsTitle }</h4>
                <p class="cookies-settings__section-perex">${ settingsData.analyticsPerex }</p>
              </div>
              <div class="cookies-settings__section-main">
                <h4 class="cookies-settings__section-sub-title">${ settingsData.marketingTitle }</h4>
                <p class="cookies-settings__section-perex">${ settingsData.marketingPerex }</p>
              </div>
            </section>` }
          </div>
          <div class="cookies-settings__footer">
              <button class="cookies-settings__btn cookies-settings__btn--secondary" data-fragment="cp.acceptSelectedButton">${ settingsData.acceptSelectedBtn }</button>
            </div>
        </div>
      </section>`,
    messages: {
      cs: {
        heading: 'Nastavení cookies: Aby&nbsp;web fungoval, jak&nbsp;má',
        perex: 'Chceme, aby&nbsp;pro&nbsp;vás&nbsp;bylo procházení webu co&nbsp;nejpříjemnější. Proto používáme soubory cookies, které ho&nbsp;pomáhají neustále rozvíjet a&nbsp;zlepšovat. Navíc nám&nbsp;a&nbsp;našim partnerům umožňují zobrazovat relevantní obsah jen&nbsp;pro&nbsp;vás. Ke&nbsp;zpracování některých cookies potřebujeme váš&nbsp;souhlas, který nám&nbsp;dáte kliknutím na&nbsp;„Povolit všechny cookies“. Nastavení si&nbsp;můžete kdykoliv upravit. Poskytnuté informace jsou v&nbsp;bezpečí a&nbsp;nedostane se&nbsp;k&nbsp;nim, kdo&nbsp;nemá. Více najdete na&nbsp;stránce <a class="cookies-policy__link" href="/cs/informace-o-cookies">Informace o&nbsp;cookies</a>.',
        closeBtn: 'Zavřít',
        settingsBtn: 'Podrobné nastavení',
        technicalBtn: 'Pouze technické cookies',
        acceptAllBtn: 'Povolit všechny cookies',
      },
      en: {
        heading: 'Keeping your site working well',
        perex: 'This website uses cookies to provide social media functions and analyse the visit rate. By clicking on the "Enable all cookies" button, you agree to storage and use of cookies. Detailed information about cookies <a class="cookies-policy__link" href="/en/cookie-information">see here</a>.',
        closeBtn: 'Close',
        settingsBtn: 'Cookies settings',
        technicalBtn: 'Only technical cookies',
        acceptAllBtn: 'Enable all cookies',
      },
      de: {
        heading: 'Damit die Website richtig funktioniert',
        perex: 'Diese Website verwendet Cookies, um Funktionen für soziale Medien anbieten zu können und die Zugriffe auf unsere Website zu analysieren. Mit dem Klicken auf den Button „Alle Cookies zulassen“ stimmen Sie der Speicherung und Verwendung von Cookies zu. Ausführliche Informationen über Cookies finden <a class="cookies-policy__link" href="/de/informationen-uber-cookies">Sie hier</a>.',
        closeBtn: 'Schließen',
        settingsBtn: 'Cookies-Einstellungen',
        technicalBtn: 'Nur technische Cookies',
        acceptAllBtn: 'Alle Cookies zulassen',
      },
      sk: {
        heading: 'Aby web fungoval tak, ako má',
        perex: 'Tento web používa na poskytovanie funkcií sociálnych médií a analýzu návštevnosti súbory cookie. Kliknutím na tlačidlo „Povoliť všetky súbory  cookie“ súhlasíte s ukladaním a používaním súborov cookie. Detailné informácie o súboroch cookie <a class="cookies-policy__link" href="/sk/informacie-o-cookies">nájdete tu</a>.',
        closeBtn: 'Zavrieť',
        settingsBtn: 'Nastavenie súborov cookie',
        technicalBtn: 'Iba technické cookies',
        acceptAllBtn: 'Povoliť všetky súbory cookie',
      },
      ru: {
        heading: 'Чтобы веб-сайт работал как положено',
        perex: 'Этот сайт использует файлы cookie для обеспечения функций социальных сетей и анализа трафика. Нажав на кнопку «Разрешить все файлы cookie», Вы соглашаетесь на хранение и использование файлов cookie. Подробную информацию о файлах cookie <a class="cookies-policy__link" href="/ru/cookie-information">можно найти здесь</a>.',
        closeBtn: 'Закрыть',
        settingsBtn: 'Настройки файлов cookies',
        technicalBtn: 'Только технические куки',
        acceptAllBtn: 'Разрешить все файлы cookies',
      },
      es: {
        heading: 'Para que la web funcione como es debido',
        perex: 'Para poder funcionar con redes sociales y para el análisis del número de visitas, esta web utiliza archivos cookies. Al hacer clic en el botón "Permitir todas las cookies", usted acepta el almacenamiento y el uso de cookies. La información detallada sobre los cookies se encuentra <a class="cookies-policy__link" href="/es/informacion-sobre-cookies">aquí</a>.',
        closeBtn: 'Cerrar',
        settingsBtn: 'Configuración de cookies',
        technicalBtn: 'Solo cookies técnicas',
        acceptAllBtn: 'Permitir todas las cookies',
      },
      hu: {
        heading: 'Hogy a webhely megfelelően működjön',
        perex: 'Ez a webhely a közösségimédia-funkciók biztosításához és a látogatottság elemzéséhez sütiket használ. Az „Összes süti engedélyezése” gombra kattintva jóváhagyhatja a sütik mentését és használatát. A sütikről <a class="cookies-policy__link" href="/hu/informacio-a-sutikrol">itt találhat</a> részletes információkat.',
        closeBtn: 'Bezárás',
        settingsBtn: 'Sütik beállítása',
        technicalBtn: 'Csak technikai sütik',
        acceptAllBtn: 'Összes süti engedélyezése',
      },
      pl: {
        heading: 'By strona internetowa działała, jak należy',
        perex: 'Ta strona internetowa w celu zapewnienia funkcji mediów społecznościowych i analizy frekwencji korzysta z plików cookies. Klikając na przycisk „Zezwól na wszystkie pliki cookies“, wyrażasz zgodę na zapisywanie i używanie plików cookies. Informacje szczegółowe o plikach cookies <a class="cookies-policy__link" href="/pl/informacje-o-cookie">znajdziesz tutaj</a>.',
        closeBtn: 'Zamknij',
        settingsBtn: 'Ustawienia plików cookies',
        technicalBtn: 'Tylko techniczne pliki cookie',
        acceptAllBtn: 'Zezwól na wszystkie pliki cookies',
      },
      fr: {
        heading: 'Pour que le site web fonctionne correctement',
        perex: 'Ce site utilise des cookies pour offrir des fonctionnalités relatives aux médias sociaux et analyser le trafic sur le site web. Cliquez sur « Autoriser tous les cookies » afin d’autoriser le stockage et l’utilisation des fichiers cookies. Des informations détaillées sur les cookies <a class="cookies-policy__link" href="/fr/informations-sur-les-cookies">Des informations détaillées sur les cookies</a>.',
        closeBtn: 'Fermer',
        settingsBtn: 'Gestion des cookies',
        technicalBtn: 'Cookies techniques uniquement',
        acceptAllBtn: 'Autoriser tous les cookies',
      },
      it: {
        heading: 'Per garantire il corretto funzionamento del sito web',
        perex: 'Questo sito web utilizza i cookie per fornire funzionalità dei social media e per monitorare gli accessi. Cliccando sul tasto “Accetta tutti i cookie” consenti di salvare e di utilizzare i file cookie. Informazioni dettagliate sui cookie <a class="cookies-policy__link" href="/it/informazioni-sui-cookie">puoi trovare qui</a>.',
        closeBtn: 'Chiudi',
        settingsBtn: 'Impostazione dei cookie',
        technicalBtn: 'Solo cookie tecnici',
        acceptAllBtn: 'Accetta tutti i cookie',
      },
    },
    settingsMessages: {
      cs: {
        heading: 'Nastavení cookies',
        perex: 'Zde si můžete nastavit, jaké soubory cookies budeme zpracovávat. Více informací najdete na stránce <a class="cookies-settings__link" href="/cs/informace-o-cookies">Informace o cookies.</a>',
        acceptAllBtn: 'Povolit všechny cookies',
        acceptSelectedBtn: 'Povolit vybrané cookies',
        checkboxStateOff: 'Vypnuto',
        checkboxStateOn: 'Zapnuto',
        closeBtn: 'Zavřít',
        technicalTitle: 'Technické cookies',
        technicalPerex: 'Jsou nutné k&nbsp;tomu, abychom vám&nbsp;zobrazili naše webové stránky a&nbsp;fungovaly vám&nbsp;tak, jak&nbsp;mají. Tyto cookies jsou&nbsp;povinné a&nbsp;nelze je&nbsp;vypnout.',
        technicalState: 'Vždy zapnuto',
        analyticsMarketingTitle: 'Analytické a&nbsp;marketingové cookies',
        analyticsTitle: 'Analytické cookies',
        analyticsPerex: 'Pomáhají analyzovat, jak&nbsp;fungují naše webové stránky z&nbsp;hlediska chování návštěvníků a&nbsp;podle toho web&nbsp;případně přizpůsobovat a&nbsp;měnit.',
        marketingTitle: 'Marketingové cookies',
        marketingPerex: 'Díky těmto cookies můžeme my&nbsp;nebo třetí strany po&nbsp;vaší návštěvě přizpůsobit nabídku našich služeb. Tato nabídka se&nbsp;vám&nbsp;potom může zobrazovat i&nbsp;mimo naše webové stránky.',
      },
      en: {
        heading: 'Cookies settings',
        perex: 'You can set which cookies will be processed here. For more information, please go to <a class="cookies-settings__link" href="/en/cookie-information">Cookie information</a>',
        acceptAllBtn: 'Enable all cookies',
        acceptSelectedBtn: 'Enable selected cookies',
        checkboxStateOff: 'OFF',
        checkboxStateOn: 'ON',
        closeBtn: 'Close',
        technicalTitle: 'Technical cookies',
        technicalPerex: 'Technical cookies are necessary for the website to be displayed and operate properly.',
        technicalState: 'Always ON',
        analyticsMarketingTitle: 'Analytical and marketing cookies',
        analyticsTitle: 'Analytical cookies',
        analyticsPerex: 'Analytical cookies help to analyze how our website works in terms of visitor behavior and to adapt and change the website accordingly.',
        marketingTitle: 'Marketing cookies',
        marketingPerex: 'Thanks to these cookies, we or third parties can customize the offer of our services after your visit. This offer can then be displayed outside of our website.',
      },
      de: {
        heading: 'Cookies-Einstellungen',
        perex: 'Hier können Sie einstellen, welche Cookies von uns verarbeitet werden. Mehr Informationen finden Sie unter <a class="cookies-settings__link" href="/de/informationen-uber-cookies">Informationen über cookies</a>',
        acceptAllBtn: 'Alle Cookies zulassen',
        acceptSelectedBtn: 'Ausgewählte Cookies zulassen',
        checkboxStateOff: 'Ausgeschaltet',
        checkboxStateOn: 'Eingeschaltet',
        closeBtn: 'Schließen',
        technicalTitle: 'Technische Cookies',
        technicalPerex: 'Sie sind erforderlich, damit wir Ihnen unsere Website anzeigen können und damit diese ordnungsgemäß funktioniert.',
        technicalState: 'Immer eingeschaltet',
        analyticsMarketingTitle: 'Analytische und marketing Cookies',
        analyticsTitle: 'Analytische Cookies',
        analyticsPerex: 'Mit ihrer Hilfe analysieren wir, wie unsere Website im Hinblick auf das Besucherverhalten funktioniert, und passen sie entsprechend an und verändern sie.',
        marketingTitle: 'Marketing Cookies',
        marketingPerex: 'Dank dieser Cookies können wir oder Dritte unser Dienstleistungsangebot nach Ihrem Besuch anpassen. Dieses Angebot kann Ihnen dann außerhalb unserer Website angezeigt werden.',
      },
      sk: {
        heading: 'Nastavenie súborov cookie',
        perex: 'Tu si môžete nastaviť, aké súbory cookie budeme spracovávať. Viac informácií nájdete na stránke <a class="cookies-settings__link" href="/sk/informacie-o-cookies">Informácie o cookies</a>',
        acceptAllBtn: 'Povoliť všetky súbory cookie',
        acceptSelectedBtn: 'Povoliť vybrané súbory cookie',
        checkboxStateOff: 'Vypnuté',
        checkboxStateOn: 'Zapnuté',
        closeBtn: 'Zavrieť',
        technicalTitle: 'Technické cookies',
        technicalPerex: 'Sú potrebné na to, aby sme vám zobrazili naše webové stránky a fungovali vám tak, ako majú.',
        technicalState: 'Vždy zapnuté',
        analyticsMarketingTitle: 'Analytické a&nbsp;marketingové cookies',
        analyticsTitle: 'Analytické cookies',
        analyticsPerex: 'Pomáhajú analyzovať, ako fungujú naše webové stránky z hľadiska správania sa návštevníkov a podľa toho web prípadne prispôsobovať a meniť.',
        marketingTitle: 'Marketingové cookies',
        marketingPerex: 'Vďaka týmto cookies môžeme my alebo tretej strany po vašej návšteve prispôsobiť ponuku našich služieb. Táto ponuka sa vám potom môže zobrazovať aj mimo naše webové stránky.',
      },
      ru: {
        heading: 'Настройки файлов cookies',
        perex: 'Здесь вы можете указать, какие файлы cookie мы будем обрабатывать. Более подробную информацию см. на странице <a class="cookies-settings__link" href="/ru/cookie-information">использованием cookies</a>',
        acceptAllBtn: 'Разрешить все файлы cookies',
        acceptSelectedBtn: 'Разрешить выбранные файлы cookie',
        checkboxStateOff: 'Выключено',
        checkboxStateOn: 'Включено',
        closeBtn: 'Закрыть',
        technicalTitle: 'Технические файлы cookie',
        technicalPerex: 'Они необходимы для того, чтобы наш сайт отображался и работал должным образом.',
        technicalState: 'Всегда включено',
        analyticsMarketingTitle: 'Аналитические и маркетинговые файлы cookie',
        analyticsTitle: 'Аналитические файлы cookie',
        analyticsPerex: 'Они помогают нам анализировать работу нашего сайта с точки зрения поведения посетителей, а также соответствующим образом приспосабливать и изменять его.',
        marketingTitle: 'Маркетинговые файлы cookie',
        marketingPerex: 'Эти файлы cookie позволяют нам или третьим лицам приспосабливать наши предложения услуг после вашего посещения. Затем это предложение может быть показано вам и за пределами нашего сайта.',
      },
      es: {
        heading: 'Configuración de cookies',
        perex: 'Aquí puede configurar los archivos cookies que trataremos. Encontrará más información en la página <a class="cookies-settings__link" href="/es/informacion-sobre-cookies">Información sobre cookies</a>',
        acceptAllBtn: 'Permitir todas las cookies',
        acceptSelectedBtn: 'Permitir las cookies seleccionadas',
        checkboxStateOff: 'Denegados',
        checkboxStateOn: 'Permitidos',
        closeBtn: 'Cerrar',
        technicalTitle: 'Cookies técnicas',
        technicalPerex: 'Son necesarias para que nuestra página web se visualice y funcione como es debido.',
        technicalState: 'Permitidos siempre',
        analyticsMarketingTitle: 'Cookies analíticas y de marketing',
        analyticsTitle: 'Cookies analíticas',
        analyticsPerex: 'Nos ayudan a analizar como funciona nuestra página web en términos del comportamiento de los visitantes y adaptarla y modificarla en consecuencia.',
        marketingTitle: 'Cookies de marketing',
        marketingPerex: 'Estos cookies nos permiten a nosotros o a terceros adaptar nuestra oferta de servicios después de su visita. Puede que esta propuesta se muestre incluso fuera de nuestra página web.',
      },
      hu: {
        heading: 'Sütik beállítása',
        perex: 'Itt állíthatja be, hogy milyen sütifájlokat használhatunk. További információk <a class="cookies-settings__link" href="/hu/informacio-a-sutikrol">Információk a sutikrol</a>',
        acceptAllBtn: 'Összes süti engedélyezése',
        acceptSelectedBtn: 'Kiválasztott sütik engedélyezése',
        checkboxStateOff: 'Kikapcsolva',
        checkboxStateOn: 'Bekapcsolva',
        closeBtn: 'Bezárás',
        technicalTitle: 'Technikai sütik',
        technicalPerex: 'Ahhoz szükségesek, hogy weboldalaink az elvárt módon jelenjenek meg és működjenek.',
        technicalState: 'Mindig bekapcsolva',
        analyticsMarketingTitle: 'Analitikus és marketingsütik',
        analyticsTitle: 'Analitikus sütik',
        analyticsPerex: 'Annak elemzését segítik, hogy weboldalaink a látogatók viselkedése/szokásai szempontjából hogyan működnek, illetve adott esetben támogatják a webhely ez alapján történő testreszabását és módosítását.',
        marketingTitle: 'Marketingsütik',
        marketingPerex: 'Lehetővé teszik számunkra vagy harmadik fél számára szolgáltatásaink kínálatának testreszabását az Ön látogatását követően. Ezzel a kínálattal azután weboldalainkon kívül is találkozhat.',
      },
      pl: {
        heading: 'Ustawienia plików cookies',
        perex: 'Tutaj możesz ustawić, jakie pliki cookie będziemy przetwarzać. Więcej informacji znajdziesz na stronie <a class="cookies-settings__link" href="/pl/informacje-o-cookie">Informacje o cookies</a>',
        acceptAllBtn: 'Zezwól na wszystkie pliki cookies',
        acceptSelectedBtn: 'Zezwól na wybrane pliki cookie',
        checkboxStateOff: 'Wyłączone',
        checkboxStateOn: 'Włączone',
        closeBtn: 'Zamknij',
        technicalTitle: 'Techniczne pliki cookies',
        technicalPerex: 'Są one niezbędne do tego, by wyświetlała Ci się nasza strona internetowa oraz by działała prawidłowo.',
        technicalState: 'Zawsze włączone',
        analyticsMarketingTitle: 'Analityczne i marketingowe pliki cookies',
        analyticsTitle: 'Analityczne pliki cookies',
        analyticsPerex: 'Pomagają analizować sposób działania naszej strony internetowej pod kątem zachowań odwiedzających oraz w jej ewentualnym dostosowaniu i zmianach.',
        marketingTitle: 'Marketingowe pliki cookies',
        marketingPerex: 'Dzięki tym plikom cookies my lub osoby trzecie możemy dostosować ofertę naszych usług po Twojej wizycie. Oferta ta może Ci się potem wyświetlać także poza naszą stroną internetową.',
      },
      fr: {
        heading: 'Gestion des cookies',
        perex: 'En cliquant ici, vous pouvez paramétrer les cookies à déposer sur votre ordinateur que nous utilisons à des fins d’analyse et de suivi. Pour plus d’informations, veuillez consulter la page <a class="cookies-settings__link" href="/fr/informations-sur-les-cookies">Informations sur les cookies</a>',
        acceptAllBtn: 'Autoriser tous les cookies',
        acceptSelectedBtn: 'Autoriser les cookies sélectionnés',
        checkboxStateOff: 'Désactivé',
        checkboxStateOn: 'Activé',
        closeBtn: 'Fermer',
        technicalTitle: 'Cookies techniques',
        technicalPerex: 'Ces cookies sont nécessaires à l’affichage et au fonctionnement optimal de notre site web.',
        technicalState: 'Toujours activé',
        analyticsMarketingTitle: 'Cookies analytiques et de marketing',
        analyticsTitle: 'Cookies analytiques',
        analyticsPerex: 'Ces cookies nous permettent d’analyser le fonctionnement de notre site web en termes de comportements des visiteurs, et, le cas échéant, personnaliser ou modifier le site web en fonction des informations collectées.',
        marketingTitle: 'Cookies marketing',
        marketingPerex: 'Ces cookies permettent à notre société ou à des tiers de personnaliser l’offre de prestations proposées suite à votre visite du site web. Cette offre peut ultérieurement s’afficher même en dehors de notre site web.',
      },
      it: {
        heading: 'Impostazione dei cookie',
        perex: 'Qui è possibile impostare quali cookie verranno utilizzati.  Per maggiori dettagli, vedere la pagina <a class="cookies-settings__link" href="/it/informazioni-sui-cookie">Informazioni sui cookie</a>',
        acceptAllBtn: 'Accetta tutti i cookie',
        acceptSelectedBtn: 'Accetta i cookie selezionati',
        checkboxStateOff: 'Disattivato',
        checkboxStateOn: 'Attivato',
        closeBtn: 'Chiudi',
        technicalTitle: 'Cookie tecnici',
        technicalPerex: 'Sono necessari per visualizzare il nostro sito web e garantirne il corretto funzionamento.',
        technicalState: 'Sempre attivo',
        analyticsMarketingTitle: 'Cookie analitici e di marketing',
        analyticsTitle: 'Cookie analitici',
        analyticsPerex: 'Aiutano ad analizzare il funzionamento del nostro sito web per quanto riguarda il comportamento dei visitatori e ad adattare e cambiare il sito in base a queste informazioni.',
        marketingTitle: 'Cookie di marketing',
        marketingPerex: 'Questi cookie consentono a noi o a terzi di adattare la nostra offerta di servizi dopo la tua visita. Questa offerta può essere visualizzata anche al di fuori del nostro sito web.',
      },
    },

    // no need to edit, there are always default values
    container: 'body',
    cookieName: 'fg_cookie_policy_accepted',
    cookieLifetime: 365,
    excludedCPClassName: 'js_hideCookiePolicy',
    gtmCodeTemplate: gtmId => `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${ gtmId }');`,
    lang: 'cs',
    position: 'bottom',
  };

  constructor(props) {
    if (!navigator.cookieEnabled) {
      return false;
    }

    this.state = {
      accepted: false,
    };

    this.props = this.constructor.defaultProps;
    this.props = merge(this.props, props);

    this.element = document.querySelector(this.props.container);

    this.objects = {};

    this.objects.isExcluded = false;
    if (this.props.excludedSelectors.length > 0) {
      this.isExcluded();
      if (this.objects.isExcluded) {
        return false;
      }
    }

    // both objects – pane & settings
    this.objects.acceptAllButtons = null;

    // pane objects
    this.objects.closeButton = null;
    this.objects.openSettingsButton = null;
    this.objects.pane = null;
    this.objects.technicalButton = null;

    // settings object
    this.objects.openSettingsLinks = null;
    this.objects.settings = null;
    this.objects.settingsClose = null;
    this.objects.settingsCheckboxAnalytics = null;
    this.objects.settingsCheckboxAnalyticsMarketing = null;
    this.objects.settingsCheckboxMarketing = null;
    this.objects.settingsStateText = null;

    this.handleAcceptSelectedClick = this.handleAcceptSelectedClick.bind(this);
    this.handleChangeCheckboxState = this.handleChangeCheckboxState.bind(this);
    this.handleCloseSettingsClick = this.handleCloseSettingsClick.bind(this);
    this.handleSubmitLevel = this.handleSubmitLevel.bind(this);
    this.handleOpenSettingsClick = this.handleOpenSettingsClick.bind(this);
    this.handleClosePolicyClick = this.handleClosePolicyClick.bind(this);

    this.init();
  }

  init() {
    this.checkAcceptedCookie();
    this.renderNewGtmContainer();

    /**
     * pokud jsem nedal souhlas se zpracovanim cookies a nenacházím na stránce informace o cookies, vyrenderuj panel
     */
    if ((!this.state.accepted || this.state.accepted <= LEVEL.CONFIG) && !(this.element.classList.contains(this.props.excludedCPClassName))) {
      this.renderPane();

      this.objects.pane = this.element.querySelector(FRAGMENTS.PANE);
      this.objects.closeButton = this.element.querySelector(FRAGMENTS.CLOSE_BTN);
      this.objects.openSettingsButton = this.element.querySelector(FRAGMENTS.OPEN_SETTINGS_BTN);
      this.objects.technicalButton = this.element.querySelector(FRAGMENTS.TECHNICAL_BTN);

      this.bindPaneEvents();
    }


    /**
     * pokud jsem na stránce, kde nerenderuju cookie lištu, tak odeber excludedCPClassName
     */
    if (this.element.classList.contains(this.props.excludedCPClassName)) {
      this.element.classList.remove(this.props.excludedCPClassName);
    }

    /**
     * vyrenderuj settings vždy, když bude vyrenderovaný obsah panelu (cookiePolicy panel)
     * nebo když na stránce najdeš fragment na nastavení-cookies
     */
    if ((this.objects.openSettingsButton) || ((this.element.querySelectorAll(FRAGMENTS.OPEN_SETTINGS_LINK)) && (this.element.querySelectorAll(FRAGMENTS.OPEN_SETTINGS_LINK).length > 0))) {
      this.renderSettings();

      this.objects.acceptAllButtons = this.element.querySelectorAll(FRAGMENTS.ACCEPT_ALL_BTN);
      this.objects.acceptSelectedButton = this.element.querySelector(FRAGMENTS.ACCEPT_SELECTED_BTN);
      this.objects.openSettingsLinks = this.element.querySelectorAll(FRAGMENTS.OPEN_SETTINGS_LINK);
      this.objects.settings = this.element.querySelector(FRAGMENTS.SETTINGS);
      this.objects.settingsCheckboxAnalytics = this.element.querySelector(FRAGMENTS.SETTINGS_CHECKBOX_ANALYTICS);
      this.objects.settingsCheckboxAnalyticsMarketing = this.element.querySelector(FRAGMENTS.SETTINGS_CHECKBOX_ANALYTICS_MARKETING);
      this.objects.settingsCheckboxMarketing = this.element.querySelector(FRAGMENTS.SETTINGS_CHECKBOX_MARKETING);
      this.objects.settingsStateText = this.element.querySelector(FRAGMENTS.SETTINGS_STATE_TEXT);
      this.objects.settingsClose = this.element.querySelector(FRAGMENTS.SETTINGS_CLOSE_BTN);

      this.bindSettingsEvents();
      this.loadCheckboxState();
    }
  }

  setState(newState) {
    this.state = {
      ...this.state,
      ...newState,
    };
  }

  // eslint-disable-next-line class-methods-use-this,no-unused-vars
  update(prevState) {
  }

  renderPane() {
    const pane = this.buildPaneCode();
    if (this.props.position === 'bottom') {
      this.element.insertAdjacentHTML('beforeend', pane);
    } else {
      this.element.insertAdjacentHTML('afterbegin', pane);
    }
  }

  renderSettings() {
    const settings = this.buildSettingsCode();
    if (this.props.position === 'bottom') {
      this.element.insertAdjacentHTML('beforeend', settings);
    } else {
      this.element.insertAdjacentHTML('afterbegin', settings);
    }
  }

  bindPaneEvents() {
    // Event listener na tlačítko `Povolit všechny cookie` je až uvnitř funkce `bindSettingsEvents`

    if (this.objects.closeButton) {
      this.objects.closeButton.addEventListener('click', this.handleClosePolicyClick);
    }

    if (this.objects.openSettingsButton) {
      this.objects.openSettingsButton.addEventListener('click', this.handleOpenSettingsClick);
    }

    if (this.objects.technicalButton) {
      this.objects.technicalButton.addEventListener('click', this.handleSubmitLevel(LEVEL.TECHNICAL));
    }
  }

  bindSettingsEvents() {
    if (this.objects.acceptAllButtons) {
      this.objects.acceptAllButtons.forEach((acceptAllBtn) => {
        acceptAllBtn.addEventListener('click', this.handleSubmitLevel(LEVEL.ANALYTICS_MARKETING));
      });
    }

    if (this.objects.openSettingsLinks) {
      this.objects.openSettingsLinks.forEach((openSettingsLink) => {
        openSettingsLink.addEventListener('click', this.handleOpenSettingsClick);
      });
    }

    if (this.objects.settingsClose) {
      this.objects.settingsClose.addEventListener('click', this.handleCloseSettingsClick);
    }

    if (this.objects.acceptSelectedButton) {
      this.objects.acceptSelectedButton.addEventListener('click', this.handleAcceptSelectedClick);
    }

    if (this.objects.settingsCheckboxAnalytics) {
      this.objects.settingsCheckboxAnalytics.addEventListener('click', this.handleChangeCheckboxState);
    }

    if (this.objects.settingsCheckboxMarketing) {
      this.objects.settingsCheckboxMarketing.addEventListener('click', this.handleChangeCheckboxState);
    }

    if (this.objects.settingsCheckboxAnalyticsMarketing) {
      this.objects.settingsCheckboxAnalyticsMarketing.addEventListener('click', this.handleChangeCheckboxState);
    }
  }

  checkAcceptedCookie() {
    const actualLevel = this.readCookie(this.props.cookieName) || false;
    this.setState({
      accepted: actualLevel,
    });
  }

  loadCheckboxState(cookieLevel = this.state.accepted) {
    if ((this.objects.settingsCheckboxAnalytics) && (cookieLevel === LEVEL.ANALYTICS || cookieLevel === LEVEL.ANALYTICS_MARKETING)) {
      this.setCheckboxState(this.objects.settingsCheckboxAnalytics);
    }
    if ((this.objects.settingsCheckboxMarketing) && (cookieLevel === LEVEL.MARKETING || cookieLevel === LEVEL.ANALYTICS_MARKETING)) {
      this.setCheckboxState(this.objects.settingsCheckboxMarketing);
    }
    if ((this.objects.settingsCheckboxAnalyticsMarketing) && (cookieLevel === LEVEL.ANALYTICS_MARKETING)) {
      this.setCheckboxState(this.objects.settingsCheckboxAnalyticsMarketing);
    }
  }

  setCheckboxState(checkboxElement) {
    const checkboxText = checkboxElement.parentNode.querySelector(FRAGMENTS.SETTINGS_STATE_TEXT);

    checkboxElement.checked = true;
    checkboxText.innerText = this.props.settingsMessages[ this.props.lang ].checkboxStateOn;
  }

  handleChangeCheckboxState(e) {
    const eventTargetParent = e.target.parentNode;
    const checkboxText = eventTargetParent.querySelector(FRAGMENTS.SETTINGS_STATE_TEXT);

    if (e.target.checked) {
      checkboxText.innerText = this.props.settingsMessages[ this.props.lang ].checkboxStateOn;
    } else {
      checkboxText.innerText = this.props.settingsMessages[ this.props.lang ].checkboxStateOff;
    }
  }

  handleSubmitLevel(level) {
    // eslint-disable-next-line no-unused-vars
    return (e) => {
      // e.preventDefault();
      this.setCookie(this.props.cookieName, level);
      this.pushActiveStateToGTM();
      this.renderNewGtmContainer();
      this.hidePane();
      this.handleCloseSettingsClick();
      this.loadCheckboxState(level);
    };
  }

  handleAcceptSelectedClick(e) {
    e.preventDefault();
    let stateAnalytics = false;
    let stateMarketing = false;
    let stateAnalyticsMarketing = false;
    let cookieLevel = LEVEL.TECHNICAL;

    if (this.objects.settingsCheckboxAnalytics) {
      stateAnalytics = this.objects.settingsCheckboxAnalytics.checked;
    }
    if (this.objects.settingsCheckboxMarketing) {
      stateMarketing = this.objects.settingsCheckboxMarketing.checked;
    }
    if (this.objects.settingsCheckboxAnalyticsMarketing) {
      stateAnalyticsMarketing = this.objects.settingsCheckboxAnalyticsMarketing.checked;
    }

    if (stateAnalytics) cookieLevel = LEVEL.ANALYTICS;
    if (stateMarketing) cookieLevel = LEVEL.MARKETING;
    if ((stateAnalytics && stateMarketing) || (stateAnalyticsMarketing)) cookieLevel = LEVEL.ANALYTICS_MARKETING;

    this.handleSubmitLevel(cookieLevel)();
  }

  handleOpenSettingsClick(e) {
    e.preventDefault();
    this.objects.settings.classList.add(this.props.activeSettingsClassName);
  }

  handleCloseSettingsClick() {
    this.objects.settings.classList.remove(this.props.activeSettingsClassName);
  }

  handleClosePolicyClick() {
    this.objects.pane.classList.add(this.props.hiddenClassName);
  }

  buildPaneCode() {
    return this.props.template({
      imgSrc: this.props.imgSrc,
      enableCloseButton: this.props.enableCloseButton,
      enableImg: this.props.enableImg,
      enableTechnicalButton: this.props.enableTechnicalButton,
      disableRwdImg: this.props.disableRwdImg && this.props.enableImg ? this.props.disableRwdImgClassName : '',
      enableModal: this.props.enableModal ? this.props.enableModalClassName : '',
      ...this.props.messages[ this.props.lang ],
    });
  }

  buildSettingsCode() {
    return this.props.settingsTemplate({
      enableSplitGTMContainer: this.props.enableSplitGTMContainer,
      ...this.props.settingsMessages[ this.props.lang ],
    });
  }

  readCookie(cookieName = this.props.cookieName) {
    const match = document.cookie.match(new RegExp(`${ cookieName }=([^;]+)`));
    if (match) return parseInt(match[ 1 ], 10);
    return -1;
  }

  setCookie(cookieName = this.props.cookieName, cookieValue) {
    const { cookieLifetime, enableIframe } = this.props;
    const d = new Date();
    const expires = new Date(d.setTime(d.getTime() + (cookieLifetime * 24 * 60 * 60 * 1000)));
    const lifetime = (cookieLifetime > 0) ? `;expires=${ expires.toUTCString() }` : '';
    const secure = location.protocol === 'https:' ? ';secure' : '';
    const sameSiteNone = location.protocol === 'https:' ? ';SameSite=None' : '';
    document.cookie = `${ cookieName }=${ cookieValue.toString() }${ lifetime };path=/${ secure }${ enableIframe ? sameSiteNone : '' }`;
  }

  hidePane() {
    if (this.objects.pane) {
      this.objects.pane.classList.add(this.props.hiddenClassName);
    }
  }

  pushActiveStateToGTM() {
    const cookieLevel = this.readCookie(this.props.cookieName);
    const level = {
      security_storage: 'granted',
      functionality_storage: 'granted',
      personalization_storage: 'granted',
      analytics_storage: (cookieLevel === 3 || cookieLevel === 5) ? 'granted' : 'denied',
      ad_storage: (cookieLevel === 4 || cookieLevel === 5) ? 'granted' : 'denied',
    };

    gtag('consent', 'update', level);
    dataLayer.push({
      event: 'consent_update',
      consent: level,
    });
  }

  renderNewGtmContainer() {
    if (this.props.enableOneGTMContainer) return;

    const cookieLevel = this.readCookie(this.props.cookieName);

    /**
     * Analytics kontejner se vyrenderuje pouze, když cookie level je 3 nebo 5
     * a zároveň musí být props `enableSplitGTMContainer` na true
     */
    if ((cookieLevel === LEVEL.ANALYTICS || cookieLevel === LEVEL.ANALYTICS_MARKETING) && (this.props.enableSplitGTMContainer)) {
      const gtmId = document.documentElement.dataset.gtmAnalytics;
      if (gtmId && gtmId !== '!NOTSET!') {
        const gtmScript = document.createElement('script');
        gtmScript.text = this.props.gtmCodeTemplate(gtmId);
        document.body.appendChild(gtmScript);
      } else {
        console.error('GTM container for analytics tags is not set!');
      }
    }

    /**
     * Marketing kontejner se vyrenderuje pouze, když cookie level je 4 nebo 5
     */
    if (cookieLevel === LEVEL.MARKETING || cookieLevel === LEVEL.ANALYTICS_MARKETING) {
      const gtmId = document.documentElement.dataset.gtmMarketing;
      if (gtmId && gtmId !== '!NOTSET!') {
        const gtmScript = document.createElement('script');
        gtmScript.text = this.props.gtmCodeTemplate(gtmId);
        document.body.appendChild(gtmScript);
      } else {
        console.error('GTM container for marketing tags is not set!');
      }
    }
  }

  isExcluded() {
    [ ...this.props.excludedSelectors ].find((excludedSelector) => {
      if (document.querySelector(excludedSelector)) {
        this.objects.isExcluded = true;
      }
      return this.objects.isExcluded;
    });
  }

}

export default (props) => new CookiePolicy({
  lang: window.projectConfig.lang || 'cs',
  ...props,
});



// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/CookiesPolicy/CookiesPolicy.js